import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { BRAND, FAQS } from "../lib/constants";
import HeroShield from "../components/HeroShield";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const FAQ = () => {
  return (
    <div data-testid="faq-page">
      {/* HERO */}
      <section className="relative overflow-hidden bg-[color:var(--isa-navy)] text-white">
        <div
          className="absolute inset-0 opacity-25 bg-cover bg-center"
          style={{ backgroundImage: `url('${BRAND.images.shieldPattern}')` }}
        />
        <div className="absolute inset-0 bg-[color:var(--isa-navy)]/85" />
        <HeroShield position="right" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-24 lg:py-32">
          <span className="eyebrow text-[color:var(--isa-gold)]">Frequently Asked Questions</span>
          <h1 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight max-w-4xl">
            Clear answers, <em className="not-italic text-[color:var(--isa-gold)]">made simple</em>.
          </h1>
          <p className="mt-7 text-base lg:text-lg font-sans text-white/80 max-w-3xl leading-relaxed">
            We believe insurance and financial planning should be easy to understand. Here are some
            of the questions we hear most — and our honest answers. Don't see yours? Just give us a call.
          </p>
        </div>
      </section>

      {/* FAQ ACCORDION */}
      <section className="py-20 lg:py-28 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="bg-[color:var(--isa-soft-gray)] border border-gray-200 px-6"
              >
                <AccordionTrigger
                  className="font-serif text-lg lg:text-xl text-[color:var(--isa-navy)] text-left hover:no-underline py-6"
                  data-testid={`faq-trigger-${i}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm font-sans text-gray-600 leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[color:var(--isa-navy)] text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-24 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-8">
            <span className="eyebrow text-[color:var(--isa-gold)]">Still Have Questions?</span>
            <h2 className="mt-4 font-serif text-3xl lg:text-5xl leading-tight">
              We're a <em className="not-italic text-[color:var(--isa-gold)]">phone call</em> away.
            </h2>
            <p className="mt-5 text-base font-sans text-white/75 max-w-2xl">
              Speak with a licensed, independent advisor today — no pressure, no obligation.
            </p>
          </div>
          <div className="lg:col-span-4 flex flex-col gap-3">
            <a href={`tel:${BRAND.phoneTel}`} className="btn-primary" data-testid="faq-cta-call">
              <Phone className="w-4 h-4" /> {BRAND.phone}
            </a>
            <Link to="/contact?form=message" className="btn-outline-gold" data-testid="faq-cta-message">
              Send a Message <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
